import { ProductType } from '../modules/partner/reducer'

export type ProductPathSegments = {
  cloud: string
  accountId: string
}

export const parseProductPathSegments = (
  pathname: string,
  product: ProductType
): ProductPathSegments | null => {
  const match = pathname.match(new RegExp(`/${product}/([^/]+)/([^/]+)`))
  if (!match) return null

  return {
    cloud: match[1],
    accountId: match[2],
  }
}
